import { useEffect, useMemo } from "react";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { selectMessage, setMessage } from "./message.slice";
import { Banner } from "@shopify/polaris";

const Message = () => {
  const dispatch = useAppDispatch();
  const message = useAppSelector(selectMessage);

  const openSnackbar = useMemo(
    () =>
      Boolean(
        message.message &&
        message.type &&
        message.showOnSnackbar &&
        !message.failSilent,
      ),
    [message],
  );

  const handleClose = () => {
    dispatch(setMessage({ message: null, type: null, errorType: null }));
  };

  useEffect(() => {
    if (!openSnackbar) return;
    const timer = setTimeout(() => {
      // do not auto close for error messages
      if (openSnackbar && message?.type !== "critical") {
        handleClose();
      }
    }, 6000); // 6 seconds for info, warning & success messages (adjust as needed)

    return () => clearTimeout(timer);
  }, [openSnackbar, handleClose]);

  return (
    <>
      {openSnackbar && (
        <Banner
          title={message.message}
          tone={message.type}
          onDismiss={handleClose}
        />
      )}
    </>
  );
};

export default Message;
